module.exports = __webpack_public_path__ + "img/Butterfly_00165.43511b08.png";